<template>
  <div class="swiper-wrapper-501">

    <div class="row product-slider-1">
      <div class="col text-right product-slider-1-title">
        <a href="javascript:void(0)" class="text-decoration-none">
          <span class="see-more-link">{{ title }}</span>
        </a>
      </div>
      <div class="col text-left product-slider-1-title-show-more">

        <router-link :to="{name:'Products',query:{category:productQuery,category_column:'slug'}}"
                     class="text-decoration-none see-more-link">
              <span class="" v-t="`product.slider.more`">
          </span>
          <span>
          <m-icon icon="arrow-left" class="custom-icon-font-size "/>
        </span>


        </router-link>
      </div>
    </div>

    <m-product-wrapper :wait-for-brand="waitForBrand" :wait-for-category="waitForCategory"
                       :product-categories="productCategories"
                       :product-brands="productBrands"
                       :product-brand-column="brandColumn"
                       :product-category-column="categoryColumn">
      <template v-slot="{products}">
        <swiper :spaceBetween="30"
                :pagination="{
           el: '.custom-pagination',
      clickable: true,  }"
                :navigation="true" :modules="modules" class="mySwiper"
                v-if="products.length > 0" ref="mySwiper"
                v-bind="swiperOptions">

          <swiper-slide v-if="showDefaultSlideItem">
            <slot></slot>
          </swiper-slide>

          <swiper-slide v-for="product in products" :key="product.id" class="">
            <m-a :href="{ name: 'Product', params: { name: product.raw_link } }" :target="productCardLinkTarget"
                 v-if="productCardLink">
              <component :is="productCardName" :offerStatus="offerStatus" :showKeywords="showKeywords"
                         :product="product"
                         class="slider-card"/>
            </m-a>
            <component v-else :is="productCardName" :offerStatus="offerStatus" :showKeywords="showKeywords"
                       :product="product"
                       class="slider-card"/>
          </swiper-slide>

          <div class="pagination-wrapper text-center ">

            <div class="custom-pagination d-inline rounded-pill ">

            </div>

          </div>

          <div class="swiper-button-prev shadow  " slot="button-prev"></div>
          <div class="swiper-button-next shadow  " slot="button-next"></div>
        </swiper>


      </template>
    </m-product-wrapper>
  </div>
</template>

<script>
import mProductWrapper from "../../Wrappers/ProductWrapper";
import mIcon from '../../Icons/Icon'
import mA from '../../Tags/A.vue'
import mProductCard309 from "../Card/ProductCard309";

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles


import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

// import required modules
import {Navigation, Autoplay, EffectFade, Pagination} from "swiper";
import {ProductSliderProps} from "./ProductSliderProps";
import {Cards} from "../../Product/Card/Cards";
import {OfferProps} from "../ProductOffer/ProductOfferProps";


export default {
  name: "ProductSlider1",
  components: {...Cards, mProductWrapper, Swiper, SwiperSlide, mProductCard309, mIcon, mA},
  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade, Pagination]
    };
  },
  props: {
    ...OfferProps,
    ...ProductSliderProps,
  },
  computed: {
    productQuery() {
      if (this.productCategories != null && this.productCategories.length > 0) {
        return this.productCategories.join(',')
      }
      return this.productCategories
    }
  },
  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          400: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          430: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          490: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          520: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          980: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 4,
          },
        },
      },
    };
  },
  beforeMount() {

    if (this.autoPlay) {
      this.swiperOptions['autoplay'] = {
        delay: this.autoPlayDuration,
        disableOnInteraction: false,
      }
    }

    this.swiperOptions.breakpoints["300"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["400"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

  }
};
</script>

<style scoped>
.see-more-link {
  color: var(--primary);
  font-size: 19px;
  font-weight: bold;
}

.slider-card {
  max-height: 500px !important;
}

.swiper-button-next, .swiper-button-prev {
  background-color: white;
  padding: 50px 20px;
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-size: 20px !important;
}

.swiper-button-next {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  translate: -9px -45px;

}

.swiper-button-prev {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  translate: 9px -45px;

}


html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}


.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-wrapper-501 :deep(.swiper) {
  padding: 35px 0;  /* برای بالا بردن سوایپر جهت بهتر ناشن دادن پجینیشن */
}

.custom-pagination{
  padding: 0 10px;
  background-color: #DDDDDD;
}

.custom-pagination :deep(.swiper-pagination-bullet){
  translate: 0 2px;
  background-color: var(--secondary); /* رنگ پس‌زمینه بولت‌ها */
  height: 12px;
  width: 12px;
  opacity: 0.8; /* شفافیت */
  margin: 0 5px; /* فاصله افقی بین بولت‌ها */
  transition: background-color 0.3s ease, transform 0.3s ease; /* انیمیشن‌ها */
}

.custom-pagination :deep(.swiper-pagination-bullet-active){
  background-color: var(--primary); /* رنگ پس‌زمینه بولت‌ها */
  border-radius: 50%; /* دایره‌ای کردن بولت‌ها */
  opacity: 0.8; /* شفافیت */
  margin: 0 5px; /* فاصله افقی بین بولت‌ها */
  transition: background-color 0.3s ease, transform 0.3s ease; /* انیمیشن‌ها */
  transform: scale(1.3); /* بزرگ‌تر شدن در هاور */

}

.custom-pagination :deep(.swiper-pagination-bullet):hover{
  background-color: var(--primary); /* رنگ تغییر یافته هنگام هاور */
  transform: scale(1.3); /* بزرگ‌تر شدن در هاور */
}


</style>